import script from "./SegmentsTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./SegmentsTable.vue?vue&type=script&setup=true&lang=ts"

import "./SegmentsTable.vue?vue&type=style&index=0&id=fd574c82&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fd574c82"]])

export default __exports__